"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputForm = exports.Input = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inputTitle = _interopRequireDefault(require("./input-title"));

var _inputStyles = require("./input-styles");

var _excluded = ["title", "titleColor", "subtitle", "isrequired", "disabled", "error", "type", "placeholder", "mask", "value", "containerstyle", "inputwrapperstyle"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Input = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var title = props.title,
      titleColor = props.titleColor,
      subtitle = props.subtitle,
      isrequired = props.isrequired,
      disabled = props.disabled,
      error = props.error,
      _props$type = props.type,
      type = _props$type === void 0 ? "text" : _props$type,
      placeholder = props.placeholder,
      mask = props.mask,
      value = props.value,
      containerstyle = props.containerstyle,
      inputwrapperstyle = props.inputwrapperstyle,
      inputProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(_inputStyles.Container, {
    as: "label",
    style: containerstyle || {}
  }, title && /*#__PURE__*/_react.default.createElement(_inputTitle.default, {
    title: title,
    subtitle: subtitle,
    required: isrequired,
    error: error,
    color: titleColor
  }), /*#__PURE__*/_react.default.createElement(_inputStyles.InputWrapper, _extends({
    error: error
  }, inputwrapperstyle), /*#__PURE__*/_react.default.createElement(_inputStyles.InputField, _extends({
    value: value,
    type: type,
    mask: mask,
    disabled: disabled,
    placeholder: placeholder,
    inputRef: ref
  }, inputProps))));
});

exports.Input = Input;

var InputForm = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var input = props.input,
      meta = props.meta,
      containerstyle = props.containerstyle,
      onChange = props.onChange,
      inputwrapperstyle = props.inputwrapperstyle;
  var error = meta.error && meta.touched;

  var handleChange = function handleChange(selectedOption) {
    if (onChange) {
      onChange(selectedOption);
    }

    input.onChange(selectedOption);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      display: "flex",
      flexDirection: "column"
    }, containerstyle)
  }, /*#__PURE__*/_react.default.createElement(Input, _extends({}, props, {
    name: input.name,
    value: input.value,
    type: input.type,
    max: input.max,
    ref: ref,
    onChange: handleChange,
    containerstyle: {
      flex: 1
    },
    error: error,
    inputwrapperstyle: _objectSpread({}, inputwrapperstyle)
  })), error && /*#__PURE__*/_react.default.createElement(_inputStyles.Erro, null, meta.error));
});

exports.InputForm = InputForm;
InputForm.prototype = {
  input: _propTypes.default.object,
  meta: _propTypes.default.object,
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  mask: _propTypes.default.string,
  isrequired: _propTypes.default.bool,
  error: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  containerstyle: _propTypes.default.object,
  inputwrapperstyle: _propTypes.default.object
};
InputForm.defaultProps = {
  input: {},
  meta: {},
  title: "Texto",
  subtitle: "",
  mask: "",
  isrequired: false,
  error: false,
  disabled: false,
  containerstyle: {},
  inputwrapperstyle: {}
};